import "./Footer.css";
import siteData from "../data/siteData.json";
import { useNavigate, useLocation } from "react-router-dom";
import { scroller } from "react-scroll";

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNav = (id) => {
    if (location.pathname !== "/") {
      // Go to home page with hash
      navigate(`/#${id}`);
    } else {
      // Already on home → smooth scroll
      scroller.scrollTo(id, {
        smooth: true,
        offset: -90,
        duration: 700,
      });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Column 1 - Brand */}
        <div className="footer-col brand">
          <img src={siteData.logo} alt="Logo" className="footer-logo" />
          <p className="footer-text">
            Trusted construction leader delivering residential and commercial excellence in Karad.
            Quality you can rely on.
          </p>
        </div>

        {/* Column 2 - Company */}
        <div className="footer-col">
          <h4>Company</h4>
          <span onClick={() => handleNav("about")}>About Us</span>
          <span onClick={() => handleNav("projects")}>Projects</span>
          <span onClick={() => handleNav("contact")}>Contact</span>
        </div>

        {/* Column 3 - Services */}
        <div className="footer-col">
          <h4>Services</h4>
          <span onClick={() => handleNav("projects")}>Construction</span>
          <span onClick={() => handleNav("gallery")}>Design & Gallery</span>
          <span onClick={() => handleNav("contact")}>Consultation</span>
        </div>

        {/* Column 4 - Location */}
        <div className="footer-col">
          <h4>Our Location</h4>
          <iframe
            title="google-map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3809.6233307819907!2d74.18847477493226!3d17.28544878358439!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc183007c0eb999%3A0x680da7d00bb00aca!2sSJ%20Construction%20office!5e0!3m2!1sen!2sin!4v1767788871252!5m2!1sen!2sin"
            width="100%"
            height="130"
            style={{ borderRadius: "8px", border: 0 }}
            loading="lazy"
          ></iframe>
        </div>

      </div>

      <div className="footer-bottom">
        © {new Date().getFullYear()} SJ Construction - All Rights Reserved.
      </div>
    </footer>
  );
}
